import { Styles, generateClasses } from 'netline-ui';

export const aboutDialogClasses = generateClasses('AboutDialog', ['root', 'paper'] as const);

const styles: Styles = () => {
  return {
    [`.${aboutDialogClasses.paper}`]: {
      minWidth: 600,
      maxWidth: 750,
      minHeight: 360,
      maxHeight: 480,
      width: 'calc(100vw - 840px)',
      height: 'calc(100vh - 652px)',
      overflow: 'hidden',
    },
  };
};

export default styles;
